import React, { Suspense } from 'react';

function lazyWithPreload(factory) {
	const Component = React.lazy(factory);
	Component.preload = () => {
		factory();
	};
	return Component;
}

const Player = lazyWithPreload(() =>
	import('video-react').then((module) => {
		return { default: module.Player };
	}),
);

const VideoPlayer = ({ playsInline, src, poster, children = null }) => {
	return (
		<>
			<link href='./css/video-player.css' rel='stylesheet' />
			<Suspense fallback={<img alt='loader' src='./media/loader.gif' />}>
				<Player playsInline={playsInline} poster={poster} src={src}>
					{children}
				</Player>
			</Suspense>
		</>
	);
};

export const preloadPlayer = Player.preload;

export default VideoPlayer;
